import { ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { routes } from './app.routes';
import { AuthService } from './services/api/auth.service';
import { ClinicApiService } from './services/api/clinic.service';
import { ProfileApiService } from './services/api/profile.service';
import { ClinicService } from './services/local/clinic.service';
import { ProfileService } from './services/local/profile.service';
import { SessionService } from './services/local/session.service';
import { authInterceptor } from './interceptors/auth.interceptor';
import { unauthorizedInterceptor } from './interceptors/unauthorized.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor, unauthorizedInterceptor])),
    provideAppInitializer(async () => {
      const auth        = inject(AuthService);
      const session     = inject(SessionService);
      const clinicApi   = inject(ClinicApiService);
      const profileApi  = inject(ProfileApiService);
      const clinicSvc   = inject(ClinicService);
      const profileSvc  = inject(ProfileService);

      await firstValueFrom(auth.tryRestoreSession());

      if (session.isAuthenticated()) {
        await Promise.all([
          clinicApi.getClinic().then(c => clinicSvc.set(c)).catch(() => {}),
          profileApi.getProfile().then(p => profileSvc.set(p)).catch(() => {}),
        ]);
      }
    }),
  ],
};
